const BASE_LANGUAGE = 'nl';

export const resolveLocalizedSticker = (enrichedValues, language) => {
    if (!enrichedValues) return undefined;

    if (language && language !== BASE_LANGUAGE) {
        return enrichedValues[`sticker_${language}`];
    }

    return enrichedValues.sticker;
};
